<template>
  <div class="listing-client-wrapper">
    <transition-group name="fade" tag="div" class="tasks__list">
      <bloc-type-client
        :client-id="data.id.toString()"
        img-name="default-user.png"
        :client-name="data.nom"
        v-for="data in datas"
        :key="data.id"
        @delete="handleDeleteClient"
        @edit="handleEditClient"
        :isModal="true"
        :noLink="true"
      ></bloc-type-client>
    </transition-group>
    <b-modal
      id="modal-confirmation"
      title="Confirmation"
      ref="confirmationModal"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      @ok="handleOk"
      :modal-class="'base-modal'"
      cancel-variant="outline-primary"
      cancel-title="Annuler"
    >
      <p>Etes-vous certain de vouloir supprimer?</p>
    </b-modal>
  </div>
</template>
<script>
import blocTypeClient from '../../components/utils/blocTypeClient'
import { mapActions } from 'vuex'
export default {
  props: {
    datas: {
      type: Array,
      require: true
    }
  },
  components: {
    blocTypeClient
  },
  data () {
    return {
      id: Number
    }
  },
  methods: {
    ...mapActions(['deleteAdminClient']),
    handleOk () {
      this.deleteAdminClient(this.id).then(async (res) => {
        this.datas.splice(this.datas.findIndex(x => x.id === parseInt(this.id, 10)), 1)
        this.$emit('deletedElement')
      }, (err) => {
        console.log(err)
      })
    },
    handleDeleteClient (id) {
      this.$refs.confirmationModal.show()
      this.id = id
    },
    handleEditClient (id) {
      this.$emit('modalEdition', id)
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/utils/blocListing.vue